var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.394531,
    y: 0.887695,
    width: 24.3952,
    height: 24.3952,
    rx: 2.90419,
    fill: "#D9EBC7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_5203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4034 14.0019V18.01H16.3825V14.4781C16.3825 14.044 16.3803 13.5041 16.2089 13.0732C16.1212 12.8527 15.9862 12.6519 15.7782 12.5075C15.57 12.3629 15.3036 12.2852 14.9713 12.2852C14.6398 12.2852 14.3657 12.3497 14.1428 12.4726C13.9188 12.5961 13.7569 12.7728 13.642 12.9801C13.4169 13.3865 13.371 13.9146 13.371 14.4145V18.01H11.35V10.7451H13.2763V11.6081V11.7841H13.4523H13.4856H13.5915L13.6411 11.6905C13.9291 11.1471 14.6454 10.5541 15.7333 10.5541C16.8923 10.5541 17.5387 10.9303 17.9092 11.5162C18.2914 12.1207 18.4034 12.982 18.4034 14.0019ZM9.50991 18.01H7.48637V10.7451H9.50991V18.01ZM8.49686 9.354C7.83588 9.354 7.29711 8.80777 7.29711 8.14718C7.29711 7.83081 7.42332 7.52723 7.64824 7.30329C7.87318 7.07932 8.17842 6.95336 8.49686 6.95336C8.8153 6.95336 9.12055 7.07932 9.34549 7.30329C9.5704 7.52723 9.69662 7.83081 9.69662 8.14718C9.69662 8.80775 9.15761 9.354 8.49686 9.354Z",
    fill: "#69A42E",
    stroke: "#69A42E",
    strokeWidth: 0.352023
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_5203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4584,
    height: 13.0388,
    fill: "white",
    transform: "translate(7.12109 6.77637)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinGreen);
export default __webpack_public_path__ + "static/media/linkedin_green.f76b8788e9963d708f5b1c50ce859f77.svg";
export { ForwardRef as ReactComponent };